//home
export const getLandingPageUrl = locale => `/${locale}`;

export const getFlightSearchPageUrl = locale => `/${locale}/flight-search`;

export const getDomesticFlightSearchPageUrl = locale => `/${locale}/flight-search/domestic`;

export const getIntFlightSearchPageUrl = locale => `/${locale}/flight-search/international`;

export const getHotelSearchPageUrl = locale => `/${locale}/hotel-search`;

export const getDomesticHotelSearchPageUrl = locale => `/${locale}/hotel-search/domestic`;

export const getIntHotelSearchPageUrl = locale => `/${locale}/hotel-search/international`;

export const getAccommodationSearchPageUrl = locale => `/${locale}/accommodation-search`;

export const getStudyAbroadPageUrl = locale => `/${locale}/study-abroad`;

export const getWorkImmigrationPageUrl = locale => `/${locale}/work-immigration`;

export const getRedirectQRCodePageUrl = locale => `/${locale}/qr-redirect/`;

//sign in
export const getLoginPageUrl = locale => `/${locale}/login`;

//flight
export const getDomesticFlightPageUrl = locale => `/${locale}/domestic-flight`;

export const getIntFlightPageUrl = locale => `/${locale}/international-flight`;

export const getRefundRulesPageUrl = locale => `/${locale}/refund-rules`;

export const getFlightAvailabilityPageUrl = locale => `/${locale}/flight-availability`;

export const getFlightAutomaticReservationPageUrl = locale => `/${locale}/flight-automatic-reserve`;

export const getFlightAutomaticReservationConfirmPageUrl = locale => `/${locale}/flight-automatic-reserve/confirm`;

//hotel
export const getHotelPageUrl = locale => `/${locale}/hotel`;

//tour
export const getTourPageUrl = locale => `/${locale}/tour`;

export const getTourInformationPageUrl = locale => `/${locale}/tour-information`;

export const getMedicalTourismPageUrl = locale => `/${locale}/medical-tourism`;

export const getMedicalTourismResultPageUrl = locale => `/${locale}/medical-tourism-result`;

export const getCountryTourPageUrl = locale => `/${locale}/country-tour`;

export const getCountryTourDetailPageUrl = locale => `/${locale}/country-tour-detail`;

//bus
export const getBusSearchPageUrl = locale => `/${locale}/bus-search`;

export const getBusPageUrl = locale => `/${locale}/bus`;

export const getBusPassengersPageUrl = locale => `/${locale}/bus-passengers`;

//wizard
export const getItineraryLayoutUrl = locale => `/${locale}/itinerary`;

export const getFavoritesPageUrl = locale => `/${locale}/itinerary/favorites`;

export const getFlightWPageUrl = locale => `/${locale}/itinerary/domestic-flight`;

export const getIntFlightWPageUrl = locale => `/${locale}/itinerary/international-flight`;

export const getHotelWPageUrl = locale => `/${locale}/itinerary/hotel`;

export const getItineraryPageUrl = locale => `/${locale}/itinerary/itinerary-page`;

//others
export const getCartPageUrl = locale => `/${locale}/cart`;

export const getFlightPassengersPageUrl = locale => `/${locale}/flight-passengers`;

export const getIntFlightPassengersPageUrl = locale => `/${locale}/int-flight-passengers`;

export const getHotelPassengersPageUrl = locale => `/${locale}/hotel-passengers`;

export const getIntHotelPassengersPageUrl = locale => `/${locale}/int-hotel-passengers`;

export const getConfirmInformationPageUrl = locale => `/${locale}/confirm-information`;

export const getPaymentResultPageUrl = locale => `/${locale}/payment-result`;

export const getLocationPageUrl = locale => `/${locale}/location-page`;

export const getAboutUsPageUrl = locale => `/${locale}/about-us`;

export const getContactUsPageUrl = locale => `/${locale}/contact-us`;

export const getSubmitComplaintsPageUrl = locale => `/${locale}/submit-complaints`;

export const getEventPageUrl = locale => `/${locale}/aesuwp`;

export const getRulesPageUrl = locale => `/${locale}/rules`;

export const getMirasPageUrl = locale => `/${locale}/miras`;

//user panel
export const getUserPanelPageUrl = locale => `/${locale}/user-panel`;

export const getUserAccountPageUrl = locale => `/${locale}/user-panel/user-account`;

export const getOrdersPageUrl = locale => `/${locale}/user-panel/orders`;

export const getFriendsIntroductionPageUrl = locale => `/${locale}/user-panel/friends-introduction`;

export const getMyItineraryPageUrl = locale => `/${locale}/user-panel/my-itinerary`;

export const getMyItineraryViewPageUrl = locale => `/${locale}/view-itinerary`;

export const getMyToursPageUrl = locale => `/${locale}/user-panel/my-tours`;

export const getPassengerPageUrl = locale => `/${locale}/user-panel/Passenger`;

export const getWalletPageUrl = locale => `/${locale}/user-panel/wallet`;

export const getSmartReservationPageUrl = locale => `/${locale}/user-panel/smart-reservation`;

export const getUserFavoritesPageUrl = locale => `/${locale}/user-panel/user-favorites`;

export const getSupportPageUrl = locale => `/${locale}/user-panel/support`;

export const getDeleteAccountPageUrl = locale => `/${locale}/user-panel/delete-account`;

export const getCustomerClubPageUrl = locale => `/${locale}/customer-club`;

//admin panel
export const getAdminPanelPageUrl = locale => `/${locale}/admin-panel`;

export const getLocationsManagmentPageUrl = locale => `/${locale}/admin-panel/locations-managment`;

export const getInformationPageUrl = locale => `/${locale}/admin-panel/information`;

export const getLocationAddPageUrl = locale => `/${locale}/admin-panel/location-add`;

export const getLocationPointPageUrl = locale => `/${locale}/admin-panel/location-point`;

export const getDefaultUrl = () => "";

export const getBusinessCardPageUrl = () => `/business-card`;

export const getPlaygroundPageUrl = () => `/playground`;
